import { load } from 'js-yaml'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseReading(q: any): any {
  return {
    uuid: q.question_uuid,
    question: q.question_text,
    options: q.question_options,
    answersIndexes: q.question_answers_indexes,
    skillIds: q.skill_ids,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseWriting(q: any): any {
  return {
    uuid: q.question_uuid,
    question: q.question_text,
    skillIds: q.skill_ids,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseLevel(level: any): any {
  const paragraphs = level.paragraphs.map(parseParagraph)
  const reading = level.reading.map(parseReading)
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const writing = level.writing ? level.writing.map(parseWriting) : null

  return {
    uuid: level.uuid,
    freckleTextLevel: level.freckle_text_level,
    isDeprecated: level.is_deprecated,
    paragraphs,
    writing,
    reading,
    audioFilename: level.audio_filename,
    context: level.context,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseElaArticle(file: any): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const articleJson = load(file) as any
  const article = articleJson[0]

  return {
    uuid: article.article_uuid,
    title: article.title,
    diagram: article.diagram,
    diagramUrl: article.diagram_url,
    genre: article.genre,
    isSelfAssignable: article.is_self_assignable,
    isOnlySocialStudies: article.is_only_social_studies,
    isOnlyScience: article.is_only_science,
    levels: article.levels.map(parseLevel),
    author: article.author,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseParagraph(p: {[key: string]: string}): any {
  const keys = Object.keys(p)
  if (keys.length === 2 || keys.length === 3) {
    if (p['picture_url'] !== undefined) {
      return {
        type: 'picture_url',
        content: p['picture_url'],
        caption: p['caption'],
      }
    }
    return {
      type: 'picture',
      content: p['picture'],
      caption: p['caption'],
    }
  }

  const type = keys[0]!
  return {
    type,
    content: p[type],
  }
}
